<template>
  <div>
    <v-text-field
      v-if="type === 'str'"
      v-model="input"
      :label="label"
      :color="colorTheme"
      :disabled="disabled"
    />
    <v-text-field
      v-else-if="type === 'json'"
      v-model="input.name"
      :label="label"
      :color="colorTheme"
      :disabled="disabled"
    />
    <v-select
      v-else-if="type === 'f'"
      v-model="input"
      :items="[
        { text: 'true', value: true },
        { text: 'false', value: false }
      ]"
      :name="input"
      :label="label"
      :color="colorTheme"
      :disabled="disabled"
    />
    <v-text-field
      v-else-if="type === 'int' || type === 'float'"
      v-model="input"
      type="number"
      :color="colorTheme"
      :label="label"
      :disabled="disabled"
    />
    <v-menu
      v-else-if="type === 'date'"
      v-model="datePicker"
      :close-on-content-click="false"
      :disabled="disabled"
      full-width
      max-width="290"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          :value="input ? formatDateLabel(input) : null"
          :label="label"
          :color="colorTheme"
          :disabled="disabled"
          prepend-icon="event"
          readonly
          v-on="on"
        />
      </template>
      <v-date-picker
        :value="input ? formatDate(input): null"
        show-current
        :color="colorTheme"
        :disabled="disabled"
        @change="e => onDatePickerChange(e)"
      />
    </v-menu>
  </div>
</template>

<script>
import _ from 'lodash';
import { formatDate, formatDateLabel } from '../../../utils/dateFormats';

export default {
  name: 'CustomField',
  props: {
    type: {
      type: String,
      default: '',
    },
    colorTheme: {
      type: String,
      default: 'blue',
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number, Boolean, Object],
      default: '',
    },
    index: {
      type: Number,
      default: null,
    },
    onChange: {
      type: Function,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formatDate,
      formatDateLabel,
      datePicker: false,
      input: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.input = newVal;
    },
    input: _.debounce(async function inputChange(value) {
      this.onChange({
        type: this.type,
        name: this.label,
        value,
        index: this.index,
      });
    }, 600),
  },
  methods: {
    onDatePickerChange(date) {
      this.input = date;
      this.datePicker = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/financialProducts/shared/CustomField.vue